export default function bindActionsOnFields(fields, actions) {
  return fields.map(field => {
    const actionsFound = actions[field.id]
    return actionsFound ? { ...field, actions: actionsFound } : field
  })
}
